module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0093.e493219c.jpg";